import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c1bedb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "partner"
}
const _hoisted_2 = {
  key: 0,
  class: "unread"
}
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = {
  key: 0,
  class: "d-unread"
}
const _hoisted_5 = { class: "d-bold" }
const _hoisted_6 = { class: "d-bold-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "partner__photo",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
        }, [
          _createVNode(_component_app_lazy_image, {
            url: _ctx.photoUrl,
            key: _ctx.photoUrl
          }, null, 8, ["url"]),
          (_ctx.conversation.unreadCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "partner__info",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.messageContact && _ctx.messageContact(...args)))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.fullName), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.conversation.previewText), 1)
        ]),
        _createElementVNode("div", {
          class: "partner__time",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.messageContact && _ctx.messageContact(...args)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.date), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([{ 'selected': _ctx.isActive }, "d-partner"])
      }, [
        _createElementVNode("div", {
          class: "d-partner__photo",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewProfile && _ctx.viewProfile(...args)))
        }, [
          _createVNode(_component_app_lazy_image, {
            url: _ctx.photoUrl,
            key: _ctx.photoUrl
          }, null, 8, ["url"]),
          (_ctx.conversation.unreadCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "d-partner__info",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.messageContact && _ctx.messageContact(...args)))
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.fullName), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.conversation.previewText), 1)
        ]),
        _createElementVNode("div", {
          class: "d-partner__time",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.messageContact && _ctx.messageContact(...args)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.date), 1)
        ])
      ], 2))
}